import { FC } from 'react';
import { Grid, Box } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { ICustomPageSection } from '../../models';

interface IHeroSection {
  section: ICustomPageSection;
}

export const HeroSection: FC<IHeroSection> = ({ section }) => {
  const classes = useStyles();
  return (
    <Grid container alignItems="center" className={classes.heroBanner}>
      {section?.sections?.map((sec, index) => {
        return (
          <Grid item xs={12} key={`${index}`}>
            <Box display="flex" alignItems="center" flexDirection="column" justifyContent="center">
              <img className={classes.heroImg} src={sec.imageUrl} alt={sec.text} />
            </Box>
          </Grid>
        );
      })}
    </Grid>
  );
};

const useStyles = makeStyles<Theme>(theme => ({
  heroBanner: {
    margin: 0
  },
  heroImg: {
    maxWidth: '100%'
  }
}));
